// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Mo-z","categoryName":"No-z","categoryImage":"Oo-z","categoryContent":"Po-z","bottomAligned":"Qo-z"};